import './Selector.css';
import Select from 'react-select';
import React from "react";

function Selector(props) {

  const handleChange = (event) => {
    if (props.type === "projects") {
      props.setData(event.label);
    } else {
      props.setData(event.label);
    }
  };

  let optionsList = null

  if (props.type === "projects") {
    optionsList = generateProjectList()
  } else if (props.type === "milestone") {
    optionsList = generateMilestoneList()
  } else if (props.type === "category") {
    optionsList = [
      { value: 1, label: 'brainstorm' },
      { value: 2, label: 'code' },
      { value: 3, label: 'design' },
      { value: 4, label: 'logistics' },]
  }
  else if (props.type === "glowGoals") {
    optionsList = [
      { value: 1, label: 'family' },
      { value: 2, label: 'food' },
      { value: 3, label: 'self care' },]
  }
  else {
    optionsList = props.options
  }

  function generateProjectList() {
    let optionsList = []
    for (const project in props.userProfile.projects) {
      let projectName = props.userProfile.projects[project].shortName
      optionsList.push({ value: project, label: projectName })
    }
    return optionsList
  }

  function generateMilestoneList() {
    let milestoneList = []
    for (const goal of props.userProfile.goals) {
      if (goal.goalType === "milestone") {
        milestoneList = milestoneList.concat(goal.milestones)
      }
    }
    let milestoneOptionsList = [{label: "general", value: "general"}, {label: "bug fix", value: "bug fix"}];
    milestoneList.forEach(function (element) {
      milestoneOptionsList.push({ label: element, value: element })
    });

    return milestoneOptionsList
  }
  function generateMatchingMilestone() {
    let mileStoneSelected = optionsList.find ((option) =>
    option.value === props.data)
    return mileStoneSelected
  }

    function generateMatchingProject() {
    let mileStoneSelected = optionsList.find ((option) =>
    option.label === props.data)
    return mileStoneSelected
  }

  let defaultValue=generateMatchingMilestone()
  let defaultProjectValue=generateMatchingProject()

  return (
    <div className="selector">
      {props.header &&
        <p className="selectOptionHeader">{props.header}</p>
      }
      {props.type === "milestone" &&
        <Select defaultValue={defaultValue} unstyled={true} onChange={handleChange} options={optionsList} className={props.className} classNamePrefix="dropdown" />
      }
      {props.type === "projects" &&
        <Select defaultValue={defaultProjectValue} unstyled={true} onChange={handleChange} options={optionsList} className={props.className} classNamePrefix="dropdown" />
      }
      {props.type !== "milestone" && props.type !== "projects" &&
        <Select defaultValue={optionsList[props.data]} unstyled={true} onChange={handleChange} options={optionsList} className={props.className} classNamePrefix="dropdown" />
      }
    </div>
  )
}

export default Selector;